import styles from "./PageSummary.module.scss"

interface Props {
  description: string;
}

export function PageSummary(props: Props) {
  const { description } = props

  return (
    <div className={styles.container}>
      {description}
    </div>
  )
}
